// extracted by mini-css-extract-plugin
export default {"background":"XCiQHg","container":"afiZLA","cards":"tfCiE0","pagination":"p9TKk8"};